import React, { Fragment } from "react";

import { Link } from "react-router-dom";
import { NavLink as RouterLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatMessage } from "../../utils/MyFunctions";
import { useIntl, FormattedMessage } from "react-intl";
import {
  Grid,
  Box,
  Typography,
  Popover,
  Menu,
  Button,
  List,
  ListItem,
  Divider,
} from "@material-ui/core";

import { Settings, Briefcase, Users, Layers } from "react-feather";

const HeaderMenu = () => {
  const intl = useIntl();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "mega-menu-popover" : undefined;

  const [anchorElMenu, setAnchorElMenu] = React.useState(null);

  const handleClickMenu = (event) => {
    setAnchorElMenu(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorElMenu(null);
  };

  return (
    <Fragment>
      <div className="app-header-menu">
        <Button
          size="medium"
          color="inherit"
          component={RouterLink}
          to="/Accueil"
          className="btn-inverse font-size-xs mx-2"
        >
          {formatMessage(intl, "header_menu_home_page")}
        </Button>
      </div>
    </Fragment>
  );
};

export default HeaderMenu;
